import React, { Component } from "react";
import PropTypes from "prop-types";
import { NavLink } from "react-router-dom";
import getEnv from "../../../helpers/common/getEnv";
import styles from "./Sidebar.scss";
import classNames from "classnames";
import SubLinkAffiliate from "./SubLinkAffiliate";

class Sidebar extends Component {
    render() {
        const baseWebApp = getEnv('baseAppUrl');

        return (
            <div className={classNames(styles.wrapper, "col-4 col-md-3 col-xl-2")}>
                <nav className={classNames(styles.nav, "flex-column")}>
                    <a className={styles.logo} target="_blank" href={baseWebApp}>Merch by SpyAMZ</a>
                    <NavLink className={classNames(styles.link, "nav-link")} to={"/a/users"}>Users</NavLink>
                    <NavLink className={classNames(styles.link, "nav-link")} to={"/a/billings"}>Billings</NavLink>
                    <NavLink className={classNames(styles.link, "nav-link")} to={"/a/statistics"}>Statistics</NavLink>
                    <NavLink className={classNames(styles.link, "nav-link")} to={"/a/events"}>Events</NavLink>
                    <NavLink className={classNames(styles.link, "nav-link")} to={"/a/upload"}>Upload</NavLink>
                    <NavLink className={classNames(styles.link, "nav-link")} to={"/a/coupon"}>Coupon</NavLink>
                    <SubLinkAffiliate/>
                </nav>
            </div>
        );
    }
}

Sidebar.propTypes = {
    any: PropTypes.any
};

export default Sidebar;


// WEBPACK FOOTER //
// ./src/app/layout/sidebar/Sidebar.js